const styles = {
  div: {
    display: "flex",
    marginTop: "16px",
    position: "relative",
    width: "100%",
    maxWidth: "240px",
  },
  imagePreview: {
    objectFit: "cover",
    borderRadius: "150px",
    width: "240px",
    height: "240px",
  },
  label: {
    position: "absolute",
    width: "100%",
    height: "100%",
    borderRadius: "150px",
    padding: "unset",
  },
  plus: {
    position: "absolute",
    bottom: "12px",
    right: "27px",
    width: "32px",
    height: "32px",
    color: "white",
    background: "#353542",
    borderRadius: "100%",
  },
  cropContainer: {
    position: "relative",
    width: "100%",
    height: "240px",
  },
};

export default styles;
